import React, { useEffect } from 'react';
import { Field, useForm } from 'react-final-form';
import PropTypes from 'prop-types';
import FieldLabelAndError from './FieldLabelAndError';
import { ErrorMessage } from './ErrorMessage';
import { requiredUtil } from '../utils';
import { BorderStyle } from './FormFieldsStyling';

const GenericSelectInputField = ({
    name,
    label,
    options,
    className,
    disabled,
    required,
    initialValue,
    clearOnUnmount,
}) => {
    const form = useForm();
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (clearOnUnmount) {
            return () => form.change(name);
        }
    }, [clearOnUnmount]);

    const inputcss =
        className ||
        `mt-1 block w-full h-8 pl-2 ml-1 rounded-md shadow-sm sm:text-sm ${BorderStyle}`;
    return (
        <Field
            name={name}
            initialValue={initialValue}
            validate={required ? requiredUtil : undefined}
        >
            {({ input, meta }) => (
                <div className="mb-4">
                    <FieldLabelAndError label={label} required={required} />
                    <div className="w-full">
                        <select
                            {...input}
                            className={inputcss}
                            disabled={disabled}
                            data-testid={name}
                        >
                            <option style={{ display: 'None' }} value={''}>
                                Select an option
                            </option>
                            {options.map((x) => (
                                <option
                                    key={x.key}
                                    value={x.value}
                                    disabled={x.disabled}
                                    hidden={x.hidden}
                                >
                                    {x.label}
                                </option>
                            ))}
                        </select>
                        <ErrorMessage meta={meta} />
                    </div>
                </div>
            )}
        </Field>
    );
};

GenericSelectInputField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.func,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    initialValue: PropTypes.string,
    clearOnUnmount: PropTypes.bool,
};

export default GenericSelectInputField;
